import { render, staticRenderFns } from "./renewalAgreement.vue?vue&type=template&id=5601c472&"
import script from "./renewalAgreement.vue?vue&type=script&lang=js&"
export * from "./renewalAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports